// extracted by mini-css-extract-plugin
var _1 = "MagneticWallItem-module__actionContainer--yz9jv";
var _2 = "MagneticWallItem-module__active--HoO43";
var _3 = "MagneticWallItem-module__animatedBackground--RK74g";
var _4 = "MagneticWallItem-module__avatar--ejPia";
var _5 = "MagneticWallItem-module__avatarContainer--N6yZv";
var _6 = "MagneticWallItem-module__avatarContainerDisabled--qPWcT";
var _7 = "MagneticWallItem-module__buttonGroup--lStoV";
var _8 = "MagneticWallItem-module__card--okHTL";
var _9 = "MagneticWallItem-module__focusable--D5oVE";
var _a = "MagneticWallItem-module__focused--b61IE";
var _b = "MagneticWallItem-module__iconButton--XSVGT";
var _c = "MagneticWallItem-module__inner--_5IAN";
var _d = "MagneticWallItem-module__overlapped--cAeG3";
var _e = "MagneticWallItem-module__popOverContainer--tEEB1";
export { _1 as "actionContainer", _2 as "active", _3 as "animatedBackground", _4 as "avatar", _5 as "avatarContainer", _6 as "avatarContainerDisabled", _7 as "buttonGroup", _8 as "card", _9 as "focusable", _a as "focused", _b as "iconButton", _c as "inner", _d as "overlapped", _e as "popOverContainer" }
